import { Trans, useTranslation } from "react-i18next";
import {
  ArrowIcon,
  BodyText,
  Content,
  Footer,
  Header,
  PrimaryButton,
  PrimaryButtonText,
  StyledDialog,
  TitleText,
} from "./styles";

function HomepageWelcomeDialog(props) {
  const { open, onClose, onComplete } = props;
  const { t } = useTranslation();

  return (
    <StyledDialog open={open} onClose={onClose} data-testid="homepage-welcome-dialog">
      <Header>
        <TitleText>{t("reset_form.welcome_title")}</TitleText>
        <div></div>
        {/* <CloseIcon
          onClick={onClose}
          aria-label={t("reset_form.welcome_close_aria_label")}
        /> */}
      </Header>
      <Content>
        <BodyText>{t("reset_form.welcome_body_1")}</BodyText>
        <BodyText>
          <Trans
            i18nKey="reset_form.welcome_body_2"
            components={{ bold: <b /> }}
          />
        </BodyText>
      </Content>
      <Footer>
        <div></div>
        {/* <SecondaryButton onClick={onClose}>
          {t("reset_form.welcome_maybe_later")}
        </SecondaryButton> */}
        <PrimaryButton onClick={onComplete} data-testid="homepage-welcome-complete-btn">
          <PrimaryButtonText>
            {t("reset_form.welcome_complete_profile")}
          </PrimaryButtonText>
          <ArrowIcon />
        </PrimaryButton>
      </Footer>
    </StyledDialog>
  );
}

export default HomepageWelcomeDialog;
